import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface TooltipState {
  id: string;
  visible: boolean;
  text: string;
  position?: { x: number; y: number };
  style?: string; // Opcioni CSS class za različite stilove
}

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  private tooltips = new Map<string, BehaviorSubject<TooltipState>>();

  getTooltipState(id: string): Observable<TooltipState> {
    if (!this.tooltips.has(id)) {
      this.tooltips.set(id, new BehaviorSubject<TooltipState>({
        id,
        visible: false,
        text: ''
      }));
    }
    return this.tooltips.get(id)!.asObservable();
  }

  showTooltip(id: string, text: string, position?: { x: number; y: number }, style?: string) {
    const tooltip = this.tooltips.get(id);
    if (tooltip) {
      tooltip.next({
        id,
        visible: true,
        text,
        position,
        style
      });
    }
  }

  hideTooltip(id: string) {
    const tooltip = this.tooltips.get(id);
    if (tooltip) {
      tooltip.next({
        id,
        visible: false,
        text: ''
      });
    }
  }

  destroyTooltip(id: string) {
    const tooltip = this.tooltips.get(id);
    if (tooltip) {
      tooltip.complete();
      this.tooltips.delete(id);
    }
  }
}